<template>
  <v-card
    class="pa-4"
    width="450px"
  >
    <v-card-text>
      <v-form
        ref="formRef"
        class="multi-col-validation"
        @submit.prevent="handleLoginFormSubmit"
      >
        <v-row>
          <v-col cols="12">
            <p class="text-2xl font-weight-semibold text--primary">
              Bem vindo!
            </p>

            <span>Por favor, insira suas credenciais para realizar o login</span>
          </v-col>
        </v-row>

        <v-text-field
          v-model="credenciais.email"
          class="mt-5 mb-3"
          dense
          outlined
          label="E-mail"
          placeholder="email@email.com"
          autocomplete="email"
          :rules="[validators.required, validators.emailValidator]"
        />

        <v-text-field
          v-model="credenciais.senha"
          class="mb-3"
          dense
          outlined
          label="Senha"
          placeholder="············"
          :type="isPasswordVisible ? 'text' : 'password'"
          :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
          :rules="[validators.required]"
          @click:append="isPasswordVisible = !isPasswordVisible"
        />

        <div class="d-flex align-center justify-space-between flex-wrap">
          <v-checkbox
            class="mt-0"
            label="Lembre-me"
            hide-details
          />

          <router-link
            :to="{ name: 'auth-trocar-senha' }"
            style="text-decoration: none;"
          >
            Esqueci minha senha
          </router-link>
        </div>

        <v-hover v-slot="{ hover }">
          <v-btn
            class="mt-3"
            block
            type="submit"
            :color="hover ? '#25D366' : 'primary'"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="secondary"
            />
            <span v-else>Login</span>
          </v-btn>
        </v-hover>
      </v-form>
    </v-card-text>

    <v-card-text class="d-flex align-center mt-0">
      <v-divider></v-divider>

      <span class="mx-5">ou</span>

      <v-divider></v-divider>
    </v-card-text>

    <v-card-text class="d-flex align-center justify-center flex-wrap mt-0">
      <span class="me-2">Ainda não tem uma conta?</span>

      <router-link
        :to="{ name: 'auth-cadastro' }"
        style="text-decoration: none;"
      >
        Faça seu cadastro agora
      </router-link>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue'
import { ref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { required, passwordValidator, emailValidator } from '@core/utils/validation'
import { useRouter } from '@/@core/utils'
import { EventBus } from '@/components/event-bus/event-bus'
import AuthService from '@/services/modules/AuthService'
import AutoatendimentoService from '@/services/modules/AutoatendimentoService'
import useForm from '@/composables/useForm'
import useLocalStorage from '@/composables/useLocalStorage'
import useCentralStore from '@/store/central'

export default {
  setup() {
    const { empresaNomeFormatado, autoatendimentoNomeFormatado, requestUrl } = storeToRefs(useCentralStore())
    const { setCentralData, updateTitle } = useCentralStore()
    const { formRef, loading } = useForm()
    const { router } = useRouter()

    const isPasswordVisible = ref(false)
    const credenciais = ref({ urlAlias: requestUrl.value, email: '', senha: '' })

    async function getCentralData() {
      if (!requestUrl.value) return
      const autoatendimento = await AutoatendimentoService.getAutoatendimentoByUrlAlias(requestUrl.value)
      setCentralData(autoatendimento)
      updateTitle()
    }

    async function handleLoginFormSubmit() {
      if (loading.value) return

      if (!formRef.value.validate()) {
        Vue.$toast.warning('Preencha os campos corretamente antes de enviar.')
        return
      }

      try {
        loading.value = true

        /*
         * loginComEmailSenha devolve o LoginResultModel inteiro (token, requerMFA,
         * precisaCompletarCadastro, ...), não a string do JWT direto -- accessToken.token é a
         * string que useLocalStorage/jwtDecode esperam.
         */
        const response = await AuthService.loginComEmailSenha(credenciais.value)

        await useLocalStorage(response.token)

        if (response.precisaCompletarCadastro) {
          router.push({
            name: 'auth-completar-cadastro',
            params: {
              empresaNomeFormatado: empresaNomeFormatado.value,
              autoatendimentoNomeFormatado: autoatendimentoNomeFormatado.value,
            },
          })
          return
        }

        await getCentralData()
        EventBus.$emit('logged-in')

        router.push({
          name: 'autoatendimentoView',
          params: {
            empresaNomeFormatado: empresaNomeFormatado.value,
            autoatendimentoNomeFormatado: autoatendimentoNomeFormatado.value,
          },
        })
      } finally {
        loading.value = false
      }
    }

    return {
      formRef,
      loading,
      isPasswordVisible,
      credenciais,
      handleLoginFormSubmit,
      validators: {
        required,
        emailValidator,
        passwordValidator,
      },
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
    }
  },
}
</script>
